import {
  CampaignRequestStatus,
  TextingCandidateConsentSource,
  TextingCandidateConsentStatus,
  TextingCandidateMessageAspect,
  TextingCandidateMessageStatus,
} from './texting.enums';

export type TextingCandidateConsent = {
  adminId: number;
  admin: {
    fullName: string;
  };
  candidateId: number;
  companyId: number;
  id: number;
  source: TextingCandidateConsentSource;
  status: TextingCandidateConsentStatus;
  statusChangedAt: string;
};

export type PhoneNumber = {
  countryCode: string;
  number: string;
};

export type SupportedCountry = {
  countryCode: string;
  countryName: string;
  requirements: string[];
};

export interface TextingSettings {
  companyId: number;
  enabled: boolean;
  phoneNumbers: PhoneNumber[];
  supportedCountries: SupportedCountry[];
  providerActive: boolean;
  freeCreditsActive?: boolean | null;
  totalCredits?: number;
  creditsUsed?: number;
  validUntil?: string;
  scheduledDeletedAt?: string | null;
  campaignRequestStatus?: CampaignRequestStatus | null;
}

export interface TextingSettingsFull extends TextingSettings {
  freeCreditsActive: boolean | null;
  totalCredits: number;
  creditsUsed: number;
  validUntil: string;
  scheduledDeletedAt: string | null;
  campaignRequestStatus: CampaignRequestStatus | null;
}

export type TextingCandidateMessage = {
  id: number;
  from: string;
  to: string;
  segmentsCount: number;
  text: string;
  status: TextingCandidateMessageStatus;
  aspect: TextingCandidateMessageAspect;
  sentBy: string;
  sendAt: string;
  sendAtTimezone: string;
  adminId: number;
  threadId: number;
  createdAt: string;
  updatedAt: string;
  unreadIds: number[];
  statusDetails: string;
  statusErrorCode: StatusErrorCode | null;
};

export type TextingCandidateMessageThread = {
  id: number;
  companyId: number;
  candidateId: number;
  to: string;
  messages: TextingCandidateMessage[];
  belongsToOtherCandidate: boolean;
  updatedAt: string;
};

export type TextingCandidateMessagePayload = {
  textJson: object | null;
  from: string;
  candidateId: number;
  threadId: number | null;
  to: string;
  sendAt?: string | null;
  sendAtTimezone?: string | null;
  date?: string;
};

export enum StatusErrorCode {
  UnsupportedError = 'unsupported_error',
  PermissionDenied = 'permission_denied',
  ToNumberWithoutConsent = 'to_number_without_consent',
  CombinationToFromNotPossible = 'combination_to_from_not_possible',
  NumberNotRegistered = 'number_not_registered',
  A2pCampaignNotRegistered = 'a2p_campaign_not_registered',
  NoCredits = 'no_credits',
  IncorrectSetup = 'incorrect_setup',
  NoNumberRegistered = 'no_number_registered',
}
